import OpeningLandingPage from 'src/lib/localization/fr/OpeningLandingPage.json'

export default {
  OpeningLandingPage,
}
